import client from "./client";

const login = (email, password) => client.post("/auth", { email, password });
const resetPassword = (email) => client.post("/auth/resetPassword", { email });
const setPassword = (user) => client.post("/auth/setPassword", user);
const getToken = () => client.get("/auth/getToken");

export default {
    login,
    resetPassword,
    setPassword,
    getToken,
};
